import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React, { useContext, useEffect, useState, useCallback, createRef, useRef } from 'react';
import { Icon } from '../index';
import ReactDOM from 'react-dom';
import { tuple } from '../_utils/type';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import { useResizeObserver, useHideDocumentScrollBar } from '../_utils/hooks'; // import { usePrevious } from '../_utils/hooks'

import { toArray } from '../_utils/react-children';
export var PlacementTypes = tuple('top', 'right', 'bottom', 'left');
var relativePostionTypes = ['relative', 'absolute', 'fixed'];
var horizontalPlacements = ['left', 'right'];
var verticalPlacements = ['top', 'bottom'];
var documentBody = document.body; // function transformSize(size: string | number, placement: string) {
//   if (typeof size === 'string') {
//     // 只考虑px 或者 %
//     devWarning(
//       !(size.endsWith('px') && size.endsWith('%')),
//       'drawer',
//       `cannot calculate drawer size: width | height for '${size}' besides px or %`,
//     )
//     if (placement === 'right' || placement === 'bottom') return size || 0
//     return size ? '-' + size : 0
//   }
//   if (placement === 'right' || placement === 'bottom') return (size || 0) + 'px'
//   return ('-' + size || 0) + 'px'
// }

var InternalDrawer = function InternalDrawer(props, ref) {
  var _classNames, _context2, _context3, _classNames2;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var drawerProps = getCompProps('Drawer', userDefaultProps, props); // 属性需要合并一遍用户定义的默认属性

  var className = drawerProps.className,
      closable = drawerProps.closable,
      closeIcon = drawerProps.closeIcon,
      children = drawerProps.children,
      onClose = drawerProps.onClose,
      keyboard = drawerProps.keyboard,
      mask = drawerProps.mask,
      maskClosable = drawerProps.maskClosable,
      maskStyle = drawerProps.maskStyle,
      maskClassName = drawerProps.maskClassName,
      placement = drawerProps.placement,
      title = drawerProps.title,
      titleStyle = drawerProps.titleStyle,
      titleClassName = drawerProps.titleClassName,
      footer = drawerProps.footer,
      footerStyle = drawerProps.footerStyle,
      footerClassName = drawerProps.footerClassName,
      visible = drawerProps.visible,
      width = drawerProps.width,
      height = drawerProps.height,
      headerStyle = drawerProps.headerStyle,
      headerClassName = drawerProps.headerClassName,
      zindex = drawerProps.zIndex,
      getContainer = drawerProps.getContainer,
      forceRender = drawerProps.forceRender,
      destroyOnClose = drawerProps.destroyOnClose,
      customPrefixcls = drawerProps.prefixCls;
  var drawerPrefixCls = getPrefixCls(prefixCls, 'drawer', customPrefixcls);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showChildren = _useState2[0],
      setShowChildren = _useState2[1];

  var _useState3 = useState(width),
      _useState4 = _slicedToArray(_useState3, 2),
      currentWidth = _useState4[0],
      setCurrentWidth = _useState4[1]; // const previousWidthRef = usePrevious(currentWidth)
  // const previousHeightRef = usePrevious(currentHeight)


  var containerRef = ref || /*#__PURE__*/createRef();
  var contentRef = useRef(null);
  devWarning(PlacementTypes.indexOf(placement) === -1, 'drawer', "cannot found drawer type '".concat(placement, "'"));
  var drawerContainer = typeof getContainer === 'function' ? getContainer() : getContainer;
  var isAtOriginalPlace = drawerContainer === false;

  if (!(drawerContainer instanceof Element) && !isAtOriginalPlace) {
    try {
      drawerContainer = document.querySelector(drawerContainer);
    } catch (error) {
      devWarning(true, 'drawer', 'getContainer"s returnValue/value is not a correct CSSSelector');
    }

    drawerContainer = documentBody;
  }

  var isBody = !drawerContainer && !isAtOriginalPlace || drawerContainer === document.body;
  useEffect(function () {
    setShowChildren(!!forceRender);
  }, [forceRender]);
  useEffect(function () {
    var node = null;
    var portalNode = containerRef.current; // 应该只有可见才能影响
    // 但是这样会有闪烁的问题

    if (!isBody && drawerContainer) {
      node = drawerContainer;
    } else if (isAtOriginalPlace) {
      node = portalNode && portalNode.parentElement;
    }

    if (node && !_includesInstanceProperty(relativePostionTypes).call(relativePostionTypes, window.getComputedStyle(node).position)) {
      devWarning(true, 'drawer', 'getContainer"s returnValue/value is not a relative/absolute/fixed positioned DOM');
    }
  }, [drawerContainer, isBody, isAtOriginalPlace, containerRef]);
  var handleContainerResize = useCallback(function (_ref) {
    var containerWidth = _ref.width;
    if (!visible && width === currentWidth) return;

    if (containerWidth < currentWidth) {
      // 这里改成操作DOM？
      setCurrentWidth(containerWidth); // 这里拿不到正确的之前的宽度
      //  if (width !== previousWidthRef!)
      // 会一直触发
    } else {
      setCurrentWidth(width);
    }
  }, [width, visible, currentWidth]);
  useResizeObserver(function () {
    var _a;

    return drawerContainer || ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.parentNode);
  }, handleContainerResize);
  useHideDocumentScrollBar(!!visible, isBody, !!mask); // 为了单测

  useEffect(function () {
    setCurrentWidth(width);
  }, [width]);
  var closeDrawer = useCallback(function () {
    onClose && onClose();
    destroyOnClose && setShowChildren(false);
  }, [onClose, destroyOnClose]);
  var escapeToCloseModal = useCallback(function (evt) {
    var _context;

    // In Internet Explorer 9 and Firefox 36 and earlier, the Esc key returns "Esc" instead of "Escape"
    if (_includesInstanceProperty(_context = ['Escape', 'Esc']).call(_context, evt.key)) {
      closeDrawer();
    }
  }, [closeDrawer]);
  useEffect(function () {
    if (keyboard) {
      document.body.addEventListener('keydown', escapeToCloseModal);
    }

    return function () {
      document.body.removeEventListener('keydown', escapeToCloseModal);
    };
  }, [keyboard, closeDrawer, escapeToCloseModal]);
  var handleMaskClick = useCallback(function () {
    if (maskClosable) {
      closeDrawer();
    }
  }, [maskClosable, closeDrawer]);
  var getHorizontalBoolAndPlacementName = useCallback(function () {
    var isHorizontal = placement === 'left' || placement === 'right';
    var placementName = "translate".concat(isHorizontal ? 'X' : 'Y');
    return {
      isHorizontal: isHorizontal,
      placementName: placementName
    };
  }, [placement]);
  var setDraerTransform = useCallback(function (_isOpen, _placementName, _value) {
    if (!contentRef.current) return;
    contentRef.current.style.transform = '';
  }, [contentRef]);
  useEffect(function () {
    var _getHorizontalBoolAnd = getHorizontalBoolAndPlacementName(),
        isHorizontal = _getHorizontalBoolAnd.isHorizontal,
        placementName = _getHorizontalBoolAnd.placementName;

    var contentValue = contentRef.current ? contentRef.current.getBoundingClientRect()[isHorizontal ? 'width' : 'height'] : 0;
    var value = (isHorizontal ? width : height) || contentValue;

    if (visible) {
      setDraerTransform(visible, placementName, value);
    }
  }, [contentRef, getHorizontalBoolAndPlacementName, height, setDraerTransform, visible, width]);
  var drawerClasses = classNames(drawerPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(drawerPrefixCls, "-hide"), !visible), _defineProperty(_classNames, "".concat(drawerPrefixCls, "-active"), visible), _defineProperty(_classNames, "".concat(drawerPrefixCls, "-not-at-body"), !isBody), _classNames));
  var headerClass = "".concat(drawerPrefixCls, "-header");

  var _getHorizontalBoolAnd2 = getHorizontalBoolAndPlacementName(),
      placementName = _getHorizontalBoolAnd2.placementName;

  var placementPos = placement === 'left' || placement === 'top' ? '-100%' : '100%';
  var transform = visible ? '' : _concatInstanceProperty(_context2 = "".concat(placementName, "(")).call(_context2, placementPos, ")");

  var containerStyle = _extends(_defineProperty({}, placement, 0), _includesInstanceProperty(horizontalPlacements).call(horizontalPlacements, placement) ? {
    width: width,
    transform: transform
  } : {
    height: height,
    transform: transform
  });

  var container = /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(drawerPrefixCls, "-container-box"), true), _defineProperty(_classNames2, "".concat(drawerPrefixCls, "-has-container-box"), drawerContainer), _defineProperty(_classNames2, _concatInstanceProperty(_context3 = "".concat(drawerPrefixCls, "-container-")).call(_context3, placement), true), _classNames2)),
    style: containerStyle,
    ref: contentRef
  }, (title || closable) && /*#__PURE__*/React.createElement("div", {
    className: classNames(headerClass, headerClassName),
    style: headerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(drawerPrefixCls, "-title"), titleClassName),
    style: titleStyle
  }, title), closable && /*#__PURE__*/React.createElement("div", {
    className: "".concat(drawerPrefixCls, "-close-icon"),
    onClick: function onClick() {
      return closeDrawer();
    }
  }, closeIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(drawerPrefixCls, "-body")
  }, (showChildren || visible) && toArray(children)), footer && /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(drawerPrefixCls, "-footer"), footerClassName),
    style: footerStyle
  }, footer));
  var opposition = !mask && _includesInstanceProperty(PlacementTypes).call(PlacementTypes, placement) ? _includesInstanceProperty(horizontalPlacements).call(horizontalPlacements, placement) ? _filterInstanceProperty(horizontalPlacements).call(horizontalPlacements, function (p) {
    return p !== placement;
  })[0] : _filterInstanceProperty(verticalPlacements).call(verticalPlacements, function (p) {
    return p !== placement;
  })[0] : '';
  var noneMaskStyle = !mask ? {
    width: containerStyle.width
  } : {};
  var comp = /*#__PURE__*/React.createElement("div", {
    className: drawerClasses,
    style: _extends(_extends({
      zIndex: zindex || 'auto'
    }, noneMaskStyle), opposition ? _defineProperty({}, opposition, 'unset') : {}),
    ref: containerRef
  }, mask && /*#__PURE__*/React.createElement("div", {
    onClick: handleMaskClick,
    className: classNames("".concat(drawerPrefixCls, "-mask"), maskClassName),
    style: maskStyle
  }), container);
  if (drawerContainer instanceof HTMLElement) return /*#__PURE__*/ReactDOM.createPortal(comp, drawerContainer);else if (drawerContainer !== false) {
    return /*#__PURE__*/ReactDOM.createPortal(comp, documentBody);
  }
  return comp;
};

var Drawer = /*#__PURE__*/React.forwardRef(InternalDrawer);
Drawer.displayName = 'Drawer';
export default Drawer;